'use strict';
var trainSummaryTpl = require('../pages/summary/summary.html');

module.exports = /*@ngInject*/ function trainSummary() {
    return {
        restrict: 'E',
        template: trainSummaryTpl,
        controller: 'SummaryMonitoringPageController',
        controllerAs: 'vm',
        scope: {},
        bindToController: true // because the scope is isolated
    };

}
